import group from "./_group.js";
import has from "./_has.js";
export default group(function(result, value, key) {
  if (has(result, key)) result[key].push(value);
  else result[key] = [value];
});
